import { useEffect, useMemo, useRef, useState } from "react";
import MobileHeader from "../../../component/MobileHeader";
import "../../../css/common.css";
import axios from "axios";

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale";

import { useNavigate } from "react-router-dom";


const floorOptions = [
    "층 선택",
    "1층",
    "2층",
    "3층",
    "4층",
    "5층",
    "6층",
    "7층",
    "8층",
    "9층",
    "10층",
];

const createEmptyCard = () => ({
    id: Date.now() + Math.random(),

    // 대상자 / 업체
    subcontractorIdx: "",
    subcontractorNM: "",

    // 기술인
    name: "",
    subcontractorEngnrIdx: "",
    subcontractorEngnrNM: "",

    // 작업지휘자
    supervisorName: "",
    supervisorEngnrIdx: "",
    supervisorEngnrNM: "",

    // 위치
    lineUid: "",
    lineName: "",
    floor: "",
    detailPlace: "",
    caughtPlace: "",

    // 일시
    caughtDT: "",

    // 평가
    evlClass: "",
    evlCategory: "",
    score: "",
    increasePT: "",
    deductedPT: "",
    totalIncreasePT: "",
    totalDeductedPT: "",

    // 내용
    equipmentName: "",
    actionDescription: "",
    detailContent: "",
    caughtNote: "",
});
export default function ViolationRegister({
    onPrev,
    personType,
    onChangeunderNM,
    onPickEngineer,
}) {
    const navigate = useNavigate();
    const [cards, setCards] = useState([createEmptyCard()]);
    const API = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("accessToken") || "";

    const persontype = personType === "17" ? "우수" : "불합리";
    const isPlus = personType === "17";
    const isMinus = personType === "18";
    const NEED_AUTH = false;

    const [userInfo, setUserInfo] = useState({
        regId: "",
        regNM: "",
        aboveIdx: "",
        aboveNM: "",
        fldIdx: "",
        fldNM: "",
    });

    const [aboveIdx, setAboveIdx] = useState("");
    const [userFldIdx, setUserFldIdx] = useState("");
    const [companyList, setCompanyList] = useState([]);
    const [lines, setLines] = useState([]);

    const [searchResultsByCardId, setSearchResultsByCardId] = useState({});
    const [loadingByCardId, setLoadingByCardId] = useState({});

    const [supervisorResultsByCardId, setSupervisorResultsByCardId] = useState({});
    const [supervisorLoadingByCardId, setSupervisorLoadingByCardId] = useState({});

    const [loading, setLoading] = useState({
        classes: false,
        categories: false,
        points: false,
        submit: false,
    });

    const [evaluationClassList, setEvaluationClassList] = useState([]);
    const [evaluationCategoryByClass, setEvaluationCategoryByClass] = useState({});
    const [pointByCategoryIdx, setPointByCategoryIdx] = useState({});

    const fetchKeyRef = useRef("");

    const authHeaders = useMemo(() => {
        if (!NEED_AUTH || !token) return undefined;
        return { Authorization: `Bearer ${token}` };
    }, [NEED_AUTH, token]);

    const classEndpoint = useMemo(() => {
        if (isPlus) return `${API}/evaluationClassPlusList`;
        if (isMinus) return `${API}/evaluationClassMinusList`;
        return null;
    }, [API, isPlus, isMinus]);

    const pointEndpoint = useMemo(() => {
        if (isPlus) return `${API}/evaluationPlusPoint`;
        if (isMinus) return `${API}/evaluationMinusPoint`;
        return null;
    }, [API, isPlus, isMinus]);

    const evlIdx = isPlus ? 17 : isMinus ? 18 : null;

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewList, setPreviewList] = useState([]);

    const parseDateTimeLocal = (value) => {
        if (!value) return null;
        return new Date(value);
    };

    const formatDateTimeLocal = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    registerLocale("ko", ko);



    const formatPreviewDateTime = (v) => {
        if (!v) return "";
        return String(v).replace("T", " ");
    };

    const DUTY_LABEL = {
        MANAGER: "관리",
        SUPERVISOR: "작업지휘자",
        INSPECTOR: "입회자",
        SIGNALMAN: "신호수",
        GUIDER: "유도자",
        CONTROLLER: "통제자",
        FIRE_WATCHER: "화기감시자",
        CHEMICAL_A_WORKER: "가스·케미칼 A급 위험작업 작업자",
        CONFINED_SPACE_WORKER: "밀폐공간 작업 참여자",
        OTHER: "기타",
    };

    const isDutyCode = (val) =>
        typeof val === "string" &&
        Object.prototype.hasOwnProperty.call(DUTY_LABEL, val.toUpperCase());

    const normalizeDuty = (raw) => {
        const s = (raw || "").toString().trim();
        if (!s) return "OTHER";
        const u = s.toUpperCase();
        if (isDutyCode(u)) return u;

        if (s.includes("관리")) return "MANAGER";
        if (s.includes("작업지휘")) return "SUPERVISOR";
        if (s.includes("입회")) return "INSPECTOR";
        if (s.includes("신호")) return "SIGNALMAN";
        if (s.includes("유도")) return "GUIDER";
        if (s.includes("통제")) return "CONTROLLER";
        if (s.includes("화기")) return "FIRE_WATCHER";
        if (s.includes("케미칼")) return "CHEMICAL_A_WORKER";
        if (s.includes("밀폐")) return "CONFINED_SPACE_WORKER";

        return "OTHER";
    };

    const dutyLabel = (val) => DUTY_LABEL[normalizeDuty(val)] || "기타";

    const normalizeBirthToYYYYMMDD = (v) => {
        if (!v) return "";
        const digits = String(v).replace(/\D/g, "");
        return digits.length >= 8 ? digits.slice(0, 8) : "";
    };

    const formatBirth = (v) => {
        const s = normalizeBirthToYYYYMMDD(v);
        return s && s.length === 8
            ? `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`
            : v || "-";
    };

    const changeCardField = (id, field, value) => {
        setCards((prev) =>
            prev.map((card) => (card.id === id ? { ...card, [field]: value } : card))
        );
    };

    const handleChange = (id, e) => {
        const { name, value } = e.target;
        changeCardField(id, name, value);
    };

    useEffect(() => {
        axios
            .get(`${API}/userinf`, {
                headers: { Authorization: token },
            })
            .then((res) => {
                const data = res.data || {};

                setUserInfo({
                    regId: data.regId || data.userId || data.uid || "",
                    regNM: data.regNM || data.userName || "",
                    aboveIdx: data.aboveIdx || "",
                    aboveNM: data.aboveContractor?.aboveNM || data.aboveNM || "",
                    fldIdx: data.fldIdx || "",
                    fldNM: data.field?.fldNM || data.fldNM || "",
                });

                setAboveIdx(data.aboveIdx || "");
                setUserFldIdx(data.fldIdx || "");
            })
            .catch((err) => {
                console.error("userinf error:", err?.response?.status, err?.response?.data);
                setUserInfo({
                    regId: "",
                    regNM: "",
                    aboveIdx: "",
                    aboveNM: "",
                    fldIdx: "",
                    fldNM: "",
                });
                setAboveIdx("");
                setUserFldIdx("");
            });
    }, [API, token]);

    useEffect(() => {
        if (!aboveIdx) {
            setCompanyList([]);
            return;
        }

        axios
            .get(`${API}/companyListByAbove`, {
                params: { aboveIdx },
                headers: { Authorization: token },
            })
            .then((res) => {
                setCompanyList(Array.isArray(res.data) ? res.data : []);
            })
            .catch((err) => {
                console.error(
                    "companyListByAbove error:",
                    err?.response?.status,
                    err?.response?.data
                );
                setCompanyList([]);
            });
    }, [API, aboveIdx, token]);

    useEffect(() => {
        if (!userFldIdx) {
            setLines([]);
            return;
        }

        axios
            .get(`${API}/lineList`, {
                params: { fldIdx: userFldIdx },
                headers: { Authorization: token },
            })
            .then((res) => {
                setLines(Array.isArray(res.data) ? res.data : []);
            })
            .catch((err) => {
                console.error("lineList error:", err?.response?.status, err?.response?.data);
                setLines([]);
            });
    }, [API, userFldIdx, token]);

    const handleCompanyChange = (cardId, underIdxStr) => {
        const underIdx = String(underIdxStr || "");
        const selected = companyList.find((c) => String(c.underIdx) === underIdx);

        setCards((prev) =>
            prev.map((card) =>
                card.id === cardId
                    ? {
                        ...card,
                        subcontractorIdx: underIdx,
                        subcontractorNM: selected?.underNM || "",

                        // 기술인 초기화
                        name: "",
                        subcontractorEngnrIdx: "",
                        subcontractorEngnrNM: "",

                        // 작업지휘자 초기화
                        supervisorName: "",
                        supervisorEngnrIdx: "",
                        supervisorEngnrNM: "",
                    }
                    : card
            )
        );

        onChangeunderNM?.({
            subcontractorIdx: underIdx,
            subcontractorNM: selected?.underNM || "",
        });

        onPickEngineer?.({ engnrIdx: "", engnrNM: "" });

        setSearchResultsByCardId((prev) => ({ ...prev, [cardId]: [] }));
        setLoadingByCardId((prev) => ({ ...prev, [cardId]: false }));

        setSupervisorResultsByCardId((prev) => ({ ...prev, [cardId]: [] }));
        setSupervisorLoadingByCardId((prev) => ({ ...prev, [cardId]: false }));
    };

    const handleLineChange = (cardId, lineValue) => {
        const selected = lines.find(
            (line) => String(line.lineName ?? line.lineNM ?? "") === String(lineValue)
        );

        setCards((prev) =>
            prev.map((card) =>
                card.id === cardId
                    ? {
                        ...card,
                        lineUid: String(selected?.lineUid ?? ""),
                        lineName: String(selected?.lineName ?? selected?.lineNM ?? ""),
                    }
                    : card
            )
        );
    };

    const searchPersonsByName = (cardId, name, subcontractorIdx) => {
        const q = (name || "").trim();

        if (!subcontractorIdx) {
            alert("업체를 먼저 선택해주세요.");
            return;
        }

        if (!userFldIdx) {
            alert("사용자 현장 정보(fldIdx)를 불러오지 못했습니다.");
            return;
        }

        if (!q) {
            setSearchResultsByCardId((prev) => ({ ...prev, [cardId]: [] }));
            return;
        }

        setLoadingByCardId((prev) => ({ ...prev, [cardId]: true }));

        axios
            .get(`${API}/person/search`, {
                params: {
                    engnrNM: q,
                    engnrFldIdx: userFldIdx,
                    engnrAffl: Number(subcontractorIdx),
                },
                headers: {
                    Authorization: token,
                },
            })
            .then((res) => {
                const resultList = Array.isArray(res.data) ? res.data : [];

                setSearchResultsByCardId((prev) => ({
                    ...prev,
                    [cardId]: resultList,
                }));

                if (resultList.length === 0) {
                    alert("기술인을 찾을 수 없습니다.");
                }
            })
            .catch((err) => {
                console.error("person search error:", err?.response?.status, err?.response?.data);
                setSearchResultsByCardId((prev) => ({
                    ...prev,
                    [cardId]: [],
                }));
                alert("기술인을 찾을 수 없습니다.");
            })
            .finally(() => {
                setLoadingByCardId((prev) => ({
                    ...prev,
                    [cardId]: false,
                }));
            });
    };

    const searchSupervisorsByName = (cardId, name, subcontractorIdx) => {
        const q = (name || "").trim();

        if (!subcontractorIdx) {
            alert("업체를 먼저 선택해주세요.");
            return;
        }

        if (!userFldIdx) {
            alert("사용자 현장 정보(fldIdx)를 불러오지 못했습니다.");
            return;
        }

        if (!q) {
            setSupervisorResultsByCardId((prev) => ({ ...prev, [cardId]: [] }));
            return;
        }

        setSupervisorLoadingByCardId((prev) => ({ ...prev, [cardId]: true }));

        axios
            .get(`${API}/supervisor/search`, {
                params: {
                    engnrNM: q,
                    engnrFldIdx: userFldIdx,
                    engnrAffl: Number(subcontractorIdx),
                    // 필요하면 컨트롤러에서 작업지휘자 필터 받을 경우 추가
                    // engnrDuty: "SUPERVISOR"
                },
                headers: {
                    Authorization: token,
                },
            })
            .then((res) => {
                const resultList = Array.isArray(res.data) ? res.data : [];

                setSupervisorResultsByCardId((prev) => ({
                    ...prev,
                    [cardId]: resultList,
                }));

                if (resultList.length === 0) {
                    alert("작업지휘자를 찾을 수 없습니다.");
                }
            })
            .catch((err) => {
                console.error(
                    "supervisor search error:",
                    err?.response?.status,
                    err?.response?.data
                );
                setSupervisorResultsByCardId((prev) => ({
                    ...prev,
                    [cardId]: [],
                }));
                alert("작업지휘자를 찾을 수 없습니다.");
            })
            .finally(() => {
                setSupervisorLoadingByCardId((prev) => ({
                    ...prev,
                    [cardId]: false,
                }));
            });
    };

    const handleEvalClassChange = (cardId, classIdx) => {
        setCards((prev) =>
            prev.map((card) =>
                card.id === cardId
                    ? {
                        ...card,
                        evlClass: String(classIdx),
                        evlCategory: "",
                        score: "",
                        increasePT: "",
                        deductedPT: "",
                        totalIncreasePT: "",
                        totalDeductedPT: "",
                    }
                    : card
            )
        );
    };

    const handleEvalCategoryChange = (cardId, categoryIdx) => {
        const rawPoint = pointByCategoryIdx[Number(categoryIdx)];
        const absPoint =
            rawPoint == null || Number.isNaN(Number(rawPoint))
                ? ""
                : String(Math.abs(Number(rawPoint)));

        setCards((prev) =>
            prev.map((card) =>
                card.id === cardId
                    ? {
                        ...card,
                        evlCategory: String(categoryIdx),
                        score: absPoint,
                        increasePT: isPlus ? Number(absPoint || 0) : "",
                        deductedPT: isMinus ? Number(absPoint || 0) : "",
                        totalIncreasePT: isPlus ? Number(absPoint || 0) : "",
                        totalDeductedPT: isMinus ? Number(absPoint || 0) : "",
                    }
                    : card
            )
        );
    };

    const handleAddCard = () => {
        setCards((prev) => [...prev, createEmptyCard()]);
    };

    const handleRemoveCard = (id) => {
        if (cards.length === 1) return;

        setCards((prev) => prev.filter((card) => card.id !== id));

        setSearchResultsByCardId((prev) => {
            const next = { ...prev };
            delete next[id];
            return next;
        });

        setLoadingByCardId((prev) => {
            const next = { ...prev };
            delete next[id];
            return next;
        });
    };

    const makeCaughtPlace = (card) => {
        return [card.floor, card.detailPlace].filter(Boolean).join(" / ");
    };

    const getSelectedWorker = (card) => {
        const hasEngineer =
            !!String(card.subcontractorEngnrIdx || "").trim() ||
            !!String(card.subcontractorEngnrNM || "").trim() ||
            !!String(card.name || "").trim();

        const hasSupervisor =
            !!String(card.supervisorEngnrIdx || "").trim() ||
            !!String(card.supervisorEngnrNM || "").trim() ||
            !!String(card.supervisorName || "").trim();

        if (hasEngineer) {
            return {
                subcontractorEngnrIdx: String(card.subcontractorEngnrIdx || ""),
                subcontractorEngnrNM: String(
                    card.subcontractorEngnrNM || card.name || ""
                ),
                selectedRole: "ENGINEER",
            };
        }

        if (hasSupervisor) {
            return {
                subcontractorEngnrIdx: String(card.supervisorEngnrIdx || ""),
                subcontractorEngnrNM: String(
                    card.supervisorEngnrNM || card.supervisorName || ""
                ),
                selectedRole: "SUPERVISOR",
            };
        }

        return {
            subcontractorEngnrIdx: "",
            subcontractorEngnrNM: "",
            selectedRole: "",
        };
    };

    const buildPayloadFromCard = (card) => {
        const hasEngineer =
            !!String(card.subcontractorEngnrIdx || "").trim() ||
            !!String(card.subcontractorEngnrNM || "").trim() ||
            !!String(card.name || "").trim();

        const hasSupervisor =
            !!String(card.supervisorEngnrIdx || "").trim() ||
            !!String(card.supervisorEngnrNM || "").trim() ||
            !!String(card.supervisorName || "").trim();

        const finalSubcontractorEngnrIdx = hasEngineer
            ? String(card.subcontractorEngnrIdx || "")
            : hasSupervisor
                ? String(card.supervisorEngnrIdx || "")
                : "";

        const finalSubcontractorEngnrNM = hasEngineer
            ? String(card.subcontractorEngnrNM || card.name || "")
            : hasSupervisor
                ? String(card.supervisorEngnrNM || card.supervisorName || "")
                : "";

        return {
            evlStatus: isPlus ? "IND_PLUS" : "IND_MINUS",

            fldIdx: String(userInfo.fldIdx || userFldIdx || ""),
            fldNM: String(userInfo.fldNM || ""),

            subcontractorIdx: String(card.subcontractorIdx || ""),
            subcontractorNM: String(card.subcontractorNM || ""),

            caughtDT: String(card.caughtDT || ""),
            caughtPlace: makeCaughtPlace(card),
            caughtNote: String(card.detailContent || ""),
            lineIdx: card.lineUid ? Number(card.lineUid) : null,

            evlIdx: String(personType || ""),
            evlClass: String(card.evlClass || ""),
            evlCategory: String(card.evlCategory || ""),

            case_count: 1,
            deductedPT: isMinus ? Number(card.score || 0) : 0,
            increasePT: isPlus ? Number(card.score || 0) : 0,
            totalDeductedPT: isMinus ? Number(card.score || 0) : 0,
            totalIncreasePT: isPlus ? Number(card.score || 0) : 0,

            regId: String(userInfo.regId || ""),
            regNM: String(userInfo.regNM || ""),

            // 최종 등록 대상자
            subcontractorEngnrIdx: finalSubcontractorEngnrIdx,
            subcontractorEngnrNM: finalSubcontractorEngnrNM,

            // 작업지휘자 정보는 별도로도 보냄
            supervisorIdx: hasSupervisor
                ? String(card.supervisorEngnrIdx || "")
                : "",
            supervisorName: hasSupervisor
                ? String(card.supervisorEngnrNM || card.supervisorName || "")
                : "",

            aboveIdx: String(userInfo.aboveIdx || aboveIdx || ""),
            aboveNM: String(userInfo.aboveNM || ""),

            equipmentName: String(card.equipmentName || ""),
            actionDescription: String(card.actionDescription || ""),
        };
    };
    const validateCard = (card, index) => {
        if (!card.subcontractorIdx) {
            alert(`${index + 1}번째 카드: 업체를 선택해주세요.`);
            return false;
        }

        const hasEngineerName = !!card.name?.trim();
        const hasEngineerSelected = !!card.subcontractorEngnrIdx;

        const hasSupervisorName = !!card.supervisorName?.trim();
        const hasSupervisorSelected = !!card.supervisorEngnrIdx;

        // 둘 다 아예 비어 있으면 막기
        if (!hasEngineerName && !hasSupervisorName) {
            alert(`${index + 1}번째 카드: 기술인 또는 작업지휘자 중 한 명은 입력해주세요.`);
            return false;
        }

        // 기술인 이름 적었는데 검색 선택 안 한 경우
        if (hasEngineerName && !hasEngineerSelected) {
            alert(`${index + 1}번째 카드: 기술인은 검색 후 선택해주세요.`);
            return false;
        }

        // 작업지휘자 이름 적었는데 검색 선택 안 한 경우
        if (hasSupervisorName && !hasSupervisorSelected) {
            alert(`${index + 1}번째 카드: 작업지휘자는 검색 후 선택해주세요.`);
            return false;
        }

        if (!card.lineUid && !card.lineName) {
            alert(`${index + 1}번째 카드: 점검 라인을 선택해주세요.`);
            return false;
        }
        if (!card.detailPlace?.trim()) {
            alert(`${index + 1}번째 카드: 세부 위치를 입력해주세요.`);
            return false;
        }
        if (!card.floor) {
            alert(`${index + 1}번째 카드: 층을 선택해주세요.`);
            return false;
        }
        if (!card.caughtDT) {
            alert(`${index + 1}번째 카드: 발생 일시를 입력해주세요.`);
            return false;
        }
        if (!card.evlClass) {
            alert(`${index + 1}번째 카드: 내용을 선택해주세요.`);
            return false;
        }
        if (!card.evlCategory) {
            alert(`${index + 1}번째 카드: 세부사항을 선택해주세요.`);
            return false;
        }
        if (!card.equipmentName?.trim()) {
            alert(`${index + 1}번째 카드: 설비명을 입력해주세요.`);
            return false;
        }
        if (!card.actionDescription?.trim()) {
            alert(`${index + 1}번째 카드: 조치 내용을 입력해주세요.`);
            return false;
        }
        if (!card.detailContent?.trim()) {
            alert(`${index + 1}번째 카드: 상세내용을 입력해주세요.`);
            return false;
        }

        return true;
    };

    const handleOpenPreview = (e) => {
        e.preventDefault();

        for (let i = 0; i < cards.length; i += 1) {
            if (!validateCard(cards[i], i)) return;
        }

        const payloadList = cards.map((card) => buildPayloadFromCard(card));
        setPreviewList(payloadList);
        setPreviewOpen(true);
    };

    const handleFinalSubmit = async () => {
        const ok = window.confirm(`${previewList.length}건의 ${persontype} 내용을 등록하시겠습니까?`);
        if (!ok) return;

        try {
            setLoading((prev) => ({ ...prev, submit: true }));

            for (const payload of previewList) {
                await axios.post(`${API}/api/diagnostic`, payload, {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                });
            }

            alert(`${previewList.length}건의 ${persontype} 등록이 완료되었습니다.`);
            navigate(
                `/mylistByDate?targetDate=${encodeURIComponent(
                    cards[0]?.caughtDT ? String(cards[0].caughtDT).split("T")[0] : ""
                )}&dateType=occurrence`
            );
            setCards([createEmptyCard()]);
            setSearchResultsByCardId({});
            setLoadingByCardId({});
            setPreviewList([]);
            setPreviewOpen(false);
        } catch (err) {
            console.error("insertDiagnostic error:", err?.response?.status, err?.response?.data);
            alert("등록 중 오류가 발생했습니다.");
        } finally {
            setLoading((prev) => ({ ...prev, submit: false }));
        }
    };

    useEffect(() => {
        setEvaluationClassList([]);
        setEvaluationCategoryByClass({});
        setPointByCategoryIdx({});
        fetchKeyRef.current = "";
    }, [personType]);

    useEffect(() => {
        if (!classEndpoint || !evlIdx) return;

        const key = `${classEndpoint}?evlIdx=${evlIdx}&auth=${NEED_AUTH ? "1" : "0"}`;
        if (fetchKeyRef.current === key) return;
        fetchKeyRef.current = key;

        const controller = new AbortController();
        setLoading((p) => ({ ...p, classes: true }));

        axios
            .get(classEndpoint, {
                params: { evlIdx },
                headers: authHeaders,
                signal: controller.signal,
            })
            .then((res) => {

                const data = Array.isArray(res.data) ? res.data : res.data?.list ?? [];
                setEvaluationClassList(data);
            })
            .catch((err) => {
                if (err.name === "CanceledError") return;
                console.error("evaluationClassList error:", err?.response?.status, err);
                setEvaluationClassList([]);
            })
            .finally(() => setLoading((p) => ({ ...p, classes: false })));

        return () => controller.abort();
    }, [classEndpoint, evlIdx, authHeaders, NEED_AUTH]);

    useEffect(() => {
        if (!evaluationClassList.length) return;

        const controller = new AbortController();
        setLoading((p) => ({ ...p, categories: true }));

        Promise.all(
            evaluationClassList.map((cls) =>
                axios
                    .get(`${API}/evaluationCategoryList`, {
                        params: { classIdx: cls.classIdx },
                        headers: authHeaders,
                        signal: controller.signal,
                    })
                    .then((resp) => ({
                        classIdx: cls.classIdx,
                        data: Array.isArray(resp.data) ? resp.data : resp.data?.list ?? [],
                    }))
                    .catch((err) => {
                        if (err.name === "CanceledError") {
                            return { classIdx: cls.classIdx, data: [] };
                        }
                        console.error(
                            "evaluationCategoryList error:",
                            cls.classIdx,
                            err?.response?.status
                        );
                        return { classIdx: cls.classIdx, data: [] };
                    })
            )
        )
            .then((rows) => {
                const byClass = {};
                rows.forEach(({ classIdx, data }) => {
                    byClass[classIdx] = data;
                });
                setEvaluationCategoryByClass(byClass);
            })
            .finally(() => setLoading((p) => ({ ...p, categories: false })));

        return () => controller.abort();
    }, [API, authHeaders, evaluationClassList]);

    useEffect(() => {
        if (!pointEndpoint) return;

        const allCategories = Object.values(evaluationCategoryByClass).flat();
        if (!allCategories.length) return;

        const controller = new AbortController();
        setLoading((p) => ({ ...p, points: true }));

        const uniqueCategoryIdxs = Array.from(
            new Set(allCategories.map((c) => c.categoryIdx).filter((v) => v != null))
        );

        Promise.all(
            uniqueCategoryIdxs.map((categoryIdx) =>
                axios
                    .get(pointEndpoint, {
                        params: { categoryIdx },
                        headers: authHeaders,
                        signal: controller.signal,
                    })
                    .then((res) => ({
                        categoryIdx,
                        point: res.data?.categoryPPoint ?? res.data?.categoryMPoint ?? null,
                    }))
                    .catch((err) => {
                        if (err.name === "CanceledError") {
                            return { categoryIdx, point: null };
                        }
                        console.error("point error:", categoryIdx, err?.response?.status);
                        return { categoryIdx, point: null };
                    })
            )
        )
            .then((rows) => {
                const map = {};
                rows.forEach(({ categoryIdx, point }) => {
                    map[categoryIdx] = point;
                });
                setPointByCategoryIdx(map);
            })
            .finally(() => setLoading((p) => ({ ...p, points: false })));

        return () => controller.abort();
    }, [pointEndpoint, authHeaders, evaluationCategoryByClass]);

    const getClassNameById = (classIdx) => {
        const found = evaluationClassList.find(
            (cls) => String(cls.classIdx) === String(classIdx)
        );
        return found?.classNM || "";
    };

    const getCategoryNameById = (classIdx, categoryIdx) => {
        const list = evaluationCategoryByClass[Number(classIdx)] || [];
        const found = list.find(
            (cat) => String(cat.categoryIdx) === String(categoryIdx)
        );
        return found?.categoryNM || "";
    };

    return (
        <div className="page">
            <div className="vr_mobile">
                <MobileHeader onPrev={onPrev} />

                <main className="main">
                    <h1 className="title">{persontype} 등록</h1>
                    <p className="sub_title">아래 추가 버튼으로 입력창을 계속 늘릴 수 있습니다.</p>

                    <form className="vr_form" onSubmit={handleOpenPreview}>
                        {cards.map((card, index) => {
                            const results = searchResultsByCardId[card.id] || [];
                            const loadingPerson = !!loadingByCardId[card.id];

                            const supervisorResults = supervisorResultsByCardId[card.id] || [];
                            const loadingSupervisor = !!supervisorLoadingByCardId[card.id];

                            const detailList = card.evlClass
                                ? evaluationCategoryByClass[Number(card.evlClass)] || []
                                : [];

                            const signedPointText = card.score
                                ? isPlus
                                    ? `+${card.score}`
                                    : isMinus
                                        ? `-${card.score}`
                                        : card.score
                                : "";

                            return (
                                <section className="vr_card" key={card.id}>
                                    <div className="vr_card_top">
                                        <div className="vr_card_index">
                                            {persontype} 건 #{index + 1}
                                        </div>

                                        {cards.length > 1 && (
                                            <button
                                                type="button"
                                                className="vr_remove_btn"
                                                onClick={() => handleRemoveCard(card.id)}
                                            >
                                                삭제
                                            </button>
                                        )}
                                    </div>

                                    <div className="vr_section">
                                        <div className="vr_section_head">
                                            <h2>대상자 정보</h2>
                                            <span>기본 정보</span>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                업체명 <em>*</em>
                                            </label>
                                            <select
                                                value={card.subcontractorIdx}
                                                onChange={(e) => handleCompanyChange(card.id, e.target.value)}
                                                required
                                            >
                                                <option value="">업체 선택</option>
                                                {companyList.map((c) => (
                                                    <option key={c.underIdx} value={String(c.underIdx)}>
                                                        {c.underNM}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                기술인 <em>*</em>
                                            </label>

                                            <div className="person-input-wrap">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    placeholder="이름 입력"
                                                    value={card.name}
                                                    onChange={(e) => {
                                                        handleChange(card.id, e);
                                                        setSearchResultsByCardId((prev) => ({
                                                            ...prev,
                                                            [card.id]: [],
                                                        }));
                                                        changeCardField(card.id, "subcontractorEngnrIdx", "");
                                                        changeCardField(card.id, "subcontractorEngnrNM", "");
                                                        onPickEngineer?.({ engnrIdx: "", engnrNM: "" });
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            searchPersonsByName(
                                                                card.id,
                                                                card.name,
                                                                card.subcontractorIdx
                                                            );
                                                        }
                                                    }}
                                                />

                                                <div className="vr btn">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            searchPersonsByName(
                                                                card.id,
                                                                card.name,
                                                                card.subcontractorIdx
                                                            )
                                                        }
                                                        disabled={
                                                            !card.name?.trim() ||
                                                            !card.subcontractorIdx ||
                                                            loadingPerson
                                                        }
                                                    >
                                                        {loadingPerson ? "조회중…" : "검색"}
                                                    </button>
                                                </div>
                                            </div>

                                            {results.length > 0 && (
                                                <select
                                                    value={card.subcontractorEngnrIdx || ""}
                                                    onChange={(e) => {
                                                        const selected = results.find(
                                                            (r) => String(r.engnrIdx ?? r.uid) === e.target.value
                                                        );

                                                        if (selected) {
                                                            const engnrIdx = selected.engnrIdx ?? selected.uid;
                                                            const engnrNM =
                                                                selected.engnrNM ?? selected.name ?? card.name ?? "";

                                                            changeCardField(
                                                                card.id,
                                                                "subcontractorEngnrIdx",
                                                                String(engnrIdx)
                                                            );
                                                            changeCardField(
                                                                card.id,
                                                                "subcontractorEngnrNM",
                                                                engnrNM
                                                            );
                                                            changeCardField(card.id, "name", engnrNM);

                                                            onPickEngineer?.({ engnrIdx, engnrNM });
                                                        } else {
                                                            changeCardField(card.id, "subcontractorEngnrIdx", "");
                                                            changeCardField(card.id, "subcontractorEngnrNM", "");
                                                            onPickEngineer?.({ engnrIdx: "", engnrNM: "" });
                                                        }
                                                    }}
                                                >
                                                    <option value="">검색 결과 선택</option>
                                                    {results.map((p) => (
                                                        <option
                                                            key={p.engnrIdx ?? p.uid}
                                                            value={String(p.engnrIdx ?? p.uid)}
                                                        >
                                                            {`${p.engnrNM ?? p.name ?? ""} / 직무: ${dutyLabel(
                                                                p.engnrDuty ?? p.position ?? ""
                                                            )} / 생년월일: ${formatBirth(
                                                                p.engnrBirthDt ?? p.birth ?? p.birthdt
                                                            )}`}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                        <div className="vr_field">
                                            <label>
                                                작업지휘자 <em>*</em>
                                            </label>

                                            <div className="person-input-wrap">
                                                <input
                                                    type="text"
                                                    name="supervisorName"
                                                    placeholder="작업지휘자 이름 입력"
                                                    value={card.supervisorName}
                                                    onChange={(e) => {
                                                        handleChange(card.id, e);
                                                        setSupervisorResultsByCardId((prev) => ({
                                                            ...prev,
                                                            [card.id]: [],
                                                        }));
                                                        changeCardField(card.id, "supervisorEngnrIdx", "");
                                                        changeCardField(card.id, "supervisorEngnrNM", "");
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            searchSupervisorsByName(
                                                                card.id,
                                                                card.supervisorName,
                                                                card.subcontractorIdx
                                                            );
                                                        }
                                                    }}
                                                />

                                                <div className="vr btn">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            searchSupervisorsByName(
                                                                card.id,
                                                                card.supervisorName,
                                                                card.subcontractorIdx
                                                            )
                                                        }
                                                        disabled={
                                                            !card.supervisorName?.trim() ||
                                                            !card.subcontractorIdx ||
                                                            loadingSupervisor
                                                        }
                                                    >
                                                        {loadingSupervisor ? "조회중…" : "검색"}
                                                    </button>
                                                </div>
                                            </div>

                                            {supervisorResults.length > 0 && (
                                                <select
                                                    value={card.supervisorEngnrIdx || ""}
                                                    onChange={(e) => {
                                                        const selected = supervisorResults.find(
                                                            (r) => String(r.engnrIdx ?? r.uid) === e.target.value
                                                        );

                                                        if (selected) {
                                                            const engnrIdx = selected.engnrIdx ?? selected.uid;
                                                            const engnrNM =
                                                                selected.engnrNM ?? selected.name ?? card.supervisorName ?? "";

                                                            changeCardField(card.id, "supervisorEngnrIdx", String(engnrIdx));
                                                            changeCardField(card.id, "supervisorEngnrNM", engnrNM);
                                                            changeCardField(card.id, "supervisorName", engnrNM);
                                                        } else {
                                                            changeCardField(card.id, "supervisorEngnrIdx", "");
                                                            changeCardField(card.id, "supervisorEngnrNM", "");
                                                        }
                                                    }}
                                                >
                                                    <option value="">검색 결과 선택</option>
                                                    {supervisorResults.map((p) => (
                                                        <option
                                                            key={p.engnrIdx ?? p.uid}
                                                            value={String(p.engnrIdx ?? p.uid)}
                                                        >
                                                            {`${p.engnrNM ?? p.name ?? ""} / 직무: ${dutyLabel(
                                                                p.engnrDuty ?? p.position ?? ""
                                                            )} / 생년월일: ${formatBirth(
                                                                p.engnrBirthDt ?? p.birth ?? p.birthdt
                                                            )}`}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </div>

                                    <div className="vr_section">
                                        <div className="vr_section_head">
                                            <h2>위치 정보</h2>
                                            <span>점검 위치</span>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                점검 라인 <em>*</em>
                                            </label>
                                            <select
                                                value={card.lineName}
                                                onChange={(e) => handleLineChange(card.id, e.target.value)}
                                                required
                                            >
                                                <option value="">점검 라인 선택</option>
                                                {lines.map((line, idx) => {
                                                    const lineValue = String(line.lineName ?? line.lineNM ?? "");
                                                    return (
                                                        <option key={line.lineUid ?? lineValue ?? idx} value={lineValue}>
                                                            {line.lineName ?? line.lineNM}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                세부 위치 <em>*</em>
                                            </label>
                                            <input
                                                type="text"
                                                name="detailPlace"
                                                placeholder="예: 동측 통로, FAB 3구역"
                                                value={card.detailPlace}
                                                onChange={(e) => handleChange(card.id, e)}
                                                required
                                            />
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                층 <em>*</em>
                                            </label>
                                            <select
                                                name="floor"
                                                value={card.floor}
                                                onChange={(e) => handleChange(card.id, e)}
                                                required
                                            >
                                                {floorOptions.map((item) => (
                                                    <option
                                                        key={item}
                                                        value={item === "층 선택" ? "" : item}
                                                        disabled={item === "층 선택"}
                                                    >
                                                        {item}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="vr_section">
                                        <div className="vr_section_head">
                                            <h2>설비 정보</h2>
                                            <span>설비 정보</span>
                                        </div>
                                        <div className="vr_field">
                                            <label>
                                                설비명 <em>*</em>
                                            </label>
                                            <input
                                                type="text"
                                                name="equipmentName"
                                                placeholder="예: 4CWCD603"
                                                value={card.equipmentName}
                                                onChange={(e) => handleChange(card.id, e)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="vr_section">
                                        <div className="vr_section_head">
                                            <h2>발생 일시</h2>
                                            <span>기록 시간</span>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                발생 일시 <em>*</em>
                                            </label>
                                            <DatePicker
                                                selected={parseDateTimeLocal(card.caughtDT)}
                                                onChange={(date) =>
                                                    changeCardField(card.id, "caughtDT", formatDateTimeLocal(date))
                                                }
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={10}
                                                dateFormat="yyyy-MM-dd HH:mm"
                                                placeholderText="발생 일시 선택"
                                                locale="ko"
                                                className="vr_custom_datepicker"
                                                calendarClassName="vr_custom_calendar"
                                                popperClassName="vr_custom_popper"
                                            />
                                        </div>
                                    </div>

                                    <div className="vr_section">
                                        <div className="vr_section_head">
                                            <h2>{persontype} 내용</h2>
                                            <span>상세 정보</span>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                내용 <em>*</em>
                                            </label>
                                            <select
                                                value={card.evlClass}
                                                onChange={(e) => handleEvalClassChange(card.id, e.target.value)}
                                                required
                                            >
                                                <option value="">선택</option>
                                                {evaluationClassList.map((cls) => (
                                                    <option key={cls.classIdx} value={String(cls.classIdx)}>
                                                        {cls.classNM}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                세부사항 <em>*</em>
                                            </label>
                                            <select
                                                value={card.evlCategory}
                                                onChange={(e) =>
                                                    handleEvalCategoryChange(card.id, e.target.value)
                                                }
                                                disabled={!card.evlClass}
                                                required
                                            >
                                                <option value="">선택</option>
                                                {detailList.map((cat) => (
                                                    <option key={cat.categoryIdx} value={String(cat.categoryIdx)}>
                                                        {cat.categoryNM}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                점수 <em>*</em>
                                            </label>
                                            <input
                                                type="text"
                                                value={signedPointText}
                                                readOnly
                                                placeholder="세부사항을 선택하면 자동 입력"
                                            />
                                        </div>

                                        <div className="vr_field">
                                            <label>
                                                상세내용 <em>*</em>
                                            </label>
                                            <textarea
                                                name="detailContent"
                                                placeholder={`${persontype} 상황을 구체적으로 입력해주세요.`}
                                                value={card.detailContent}
                                                onChange={(e) => handleChange(card.id, e)}
                                                rows={5}
                                                required
                                            />
                                        </div>
                                        <div className="vr_field">
                                            <label>
                                                조치 내용 <em>*</em>
                                            </label>
                                            <textarea
                                                name="actionDescription"
                                                placeholder="예: 사용 중지 조치, 안전커버 설치, 작업 전 교육 실시"
                                                value={card.actionDescription}
                                                onChange={(e) => handleChange(card.id, e)}
                                                rows={4}
                                                required
                                            />
                                        </div>
                                    </div>
                                </section>
                            );
                        })}

                        <div className="vr_action_row btn">
                            <button type="button" className="vr_add_btn" onClick={handleAddCard}>
                                + 추가
                            </button>
                        </div>

                        <div className="btn">
                            <button
                                type="submit"
                                disabled={
                                    loading.classes ||
                                    loading.categories ||
                                    loading.points ||
                                    loading.submit
                                }
                            >
                                {loading.submit ? "등록중..." : "등록"}
                            </button>
                        </div>
                    </form>
                    {previewOpen && (
                        <div className="vr_preview_overlay">
                            <div className="vr_preview_modal">
                                <div className="vr_preview_head">
                                    <h2>내용을 확인해주세요</h2>
                                    <button
                                        type="button"
                                        className="vr_preview_close"
                                        onClick={() => setPreviewOpen(false)}
                                    >
                                        ✕
                                    </button>
                                </div>

                                <div className="vr_preview_body">
                                    {cards.map((card, index) => (
                                        <div className="vr_preview_card" key={card.id}>
                                            <div className="vr_preview_title">
                                                {persontype} 건 #{index + 1}
                                            </div>

                                            <div className="vr_preview_grid">
                                                <div><strong>업체명</strong><span>{card.subcontractorNM || "-"}</span></div>
                                                <div><strong>기술인</strong><span>{card.subcontractorEngnrNM || card.name || "-"}</span></div>
                                                <div><strong>작업지휘자</strong><span>{card.supervisorEngnrNM || card.supervisorName || "-"}</span></div>
                                                <div><strong>점검 라인</strong><span>{card.lineName || "-"}</span></div>
                                                <div><strong>층</strong><span>{card.floor || "-"}</span></div>
                                                <div><strong>세부 위치</strong><span>{card.detailPlace || "-"}</span></div>
                                                <div><strong>일시</strong><span>{formatPreviewDateTime(card.caughtDT) || "-"}</span></div>
                                                <div><strong>내용</strong><span>{getClassNameById(card.evlClass) || "-"}</span></div>
                                                <div><strong>세부사항</strong><span>{getCategoryNameById(card.evlClass, card.evlCategory) || "-"}</span></div>
                                                <div><strong>점수</strong><span>{isPlus ? `+${card.score || 0}` : `-${card.score || 0}`}</span></div>
                                                <div className="full">
                                                    <strong>상세내용</strong>
                                                    <span>{card.detailContent || "-"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="vr_preview_actions">
                                    <button
                                        type="button"
                                        className="vr_preview_cancel"
                                        onClick={() => setPreviewOpen(false)}
                                    >
                                        수정하기
                                    </button>

                                    <button
                                        type="button"
                                        className="vr_preview_submit"
                                        onClick={handleFinalSubmit}
                                        disabled={loading.submit}
                                    >
                                        {loading.submit ? "등록중..." : "등록"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
}